import axios from "axios";

const getCookie = (cookie) => {
    var data = document.cookie.split('; ').find(row => row.startsWith(`${cookie}=`));
    if (data)
      return data.split('=')[1];
}

const CookieLoad = async() => {
    var user;
    if(process.env.NODE_ENV === "development"){
        user = {
            user_id: process.env.REACT_APP_TEST_USER_ID,
            class_id: process.env.REACT_APP_TEST_CLASS_ID,
            group_id: process.env.REACT_APP_TEST_GROUP_ID, 
            department: process.env.REACT_APP_TEST_DEPARTMENT, 
        }
    }else{
        user = {
            user_id: getCookie('user_id'),
            class_id: getCookie('class_id'),
            group_id: getCookie('group_id'),
            first_name: getCookie('first_name'),
            last_name: getCookie('last_name'),
            type: getCookie('type'),
            role: getCookie('role'),
            department: getCookie('department'),
        };
    }

    const response = await axios.post(`${process.env.REACT_APP_API_HOST}/api/auth/token`, {user: user})
    
    const tokens = {
        access_token: response.data.accessToken,
        refresh_token: response.data.refreshToken,
    }

    localStorage.setItem('user', JSON.stringify(tokens));
    
    return tokens;
}

export default CookieLoad